import { Box, styled, Typography } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
  borderRadius: 16,
  padding: '16px 20px',
  gap: 10,
  marginTop: 32,
});

export const StepsContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const StepRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: 16,
});

export const Circle = styled(Box)({
  width: 22,
  height: 22,
  borderRadius: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 4,
  flexShrink: 0,
});

export const CircleNumber = styled(Typography)({
  fontFamily: 'GT Walsheim',
  fontWeight: 700,
  fontSize: 12,
  lineHeight: '14px',
  letterSpacing: '-0.02em',
  textAlign: 'center',
});

export const StepTitle = styled(Typography)({
  fontFamily: 'GT Walsheim',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '-0.02em',
  flex: 1,
});

export const StepDuration = styled(Typography)({
  fontFamily: 'GT Walsheim',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '-0.02em',
  textAlign: 'right',
});

export const Separator = styled(Box)({
  width: '100%',
  height: 1,
});
